<template>
    <div>
        <v-dialog v-model="dialog" max-width="700px">
            <LabeledCard :label="$t('Фильтрация')">
                <slot>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    :label="$t('Код объекта')"
                                    v-model="obj_contract_number"
                                    dense
                                    outlined
                                    :hint="this.$t('Введите полное или частичное значение')"
                                    hide-details
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-autocomplete
                                    :label="$t('Наименование объекта')"
                                    :items="OLT"
                                    item-text="object_name"
                                    item-value="obj_suppl_rid"
                                    v-model="obj_suppl_rids"
                                    multiple
                                    dense
                                    outlined
                                    hide-details
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-autocomplete
                                    :label="$t('Адрес объекта')"
                                    :items="ALT"
                                    item-text="address_full_name"
                                    item-value="address_rid"
                                    v-model="address_rids"
                                    multiple
                                    dense
                                    outlined
                                    hide-details
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-autocomplete
                                    :label="$t('Административный район')"
                                    :items="DLT"
                                    item-text="district_name"
                                    item-value="district_rid"
                                    v-model="district_rids"
                                    multiple
                                    dense
                                    outlined
                                    hide-details
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-autocomplete
                                    :label="$t('Эксплуатационный район')"
                                    :items="EDLT"
                                    item-text="exploit_district_name"
                                    item-value="exploit_district_rid"
                                    v-model="exploit_district_rids"
                                    multiple
                                    dense
                                    outlined
                                    hide-details
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-autocomplete
                                    :label="$t('Тепловой участок')"
                                    :items="EALT"
                                    item-text="exploit_area_name"
                                    item-value="exploit_area_rid"
                                    v-model="exploit_area_rids"
                                    multiple
                                    dense
                                    outlined
                                    hide-details
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-autocomplete
                                    :label="$t('Инженер района')"
                                    :items="ELT"
                                    item-text="person_ea_name_show"
                                    item-value="engineer_rid"
                                    v-model="engineer_rids"
                                    multiple
                                    dense
                                    outlined
                                    hide-details
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" class="d-flex justify-space-between justify-sm-end">
                                <v-btn @click="dialog = false" outlined color="primary" class="rounded-btn">{{ $t('Закрыть') }}</v-btn>
                                <v-btn @click="filterItems" color="primary" class="rounded-btn ml-sm-3">{{ $t('Применить') }}</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </slot>
            </LabeledCard>
        </v-dialog>
        <v-btn :title="$t('Фильтр')" icon :color="$vuetify.theme.themes.dark.primary" class="mr-1" @click="openFilter" :disabled="!SelectedContract">
            <v-icon>mdi-filter</v-icon>
        </v-btn>
        <v-btn :title="$t('Очистить фильтр')" icon :color="$vuetify.theme.themes.dark.primary" :disabled="!Filter" @click="clearFilter">
            <v-icon :color="'red'">mdi-filter-remove</v-icon>
        </v-btn>
    </div>
</template>

<script>
import translate from '@/utils/translate.util';
import LabeledCard from '@/components/ui/LabeledCard';
import { getFilterArray, getFilterArrayWithDates } from '@/utils/filter.util';
import { mapActions, mapState } from 'vuex';

export default {
    components: {
        LabeledCard
    },
    data: () => ({
        dialog: false,
        address_rids: [],
        engineer_rids: [],
        exploit_area_rids: [],
        exploit_district_rids: [],
        district_rids: [],
        obj_suppl_rids: [],
        obj_contract_number: null
    }),
    watch: {},
    computed: {
        ...mapState('request', [
            'AdresList',
            'EngineerList',
            'ExploitAreaList',
            'ExploitDistrictList',
            'DistrictList',
            'ObjList',
            'Filter',
            'SelectedContract',
            'ContractPagination',
            'ObjectPagination'
        ]),
        ALT() {
            return translate(this.AdresList, 'full', this.$i18n.locale);
        },
        ELT() {
            return translate(this.EngineerList, 'full', this.$i18n.locale);
        },
        EALT() {
            return translate(this.ExploitAreaList, 'full', this.$i18n.locale);
        },
        EDLT() {
            return translate(this.ExploitDistrictList, 'full', this.$i18n.locale);
        },
        DLT() {
            return translate(this.DistrictList, 'full', this.$i18n.locale);
        },
        OLT() {
            return translate(this.ObjList, 'full', this.$i18n.locale);
        }
    },
    methods: {
        ...mapActions('request', ['loadFilters', 'getContractObjects']),
        async clearFilter() {
            this.address_rids = [];
            this.engineer_rids = [];
            this.exploit_area_rids = [];
            this.exploit_district_rids = [];
            this.district_rids = [];
            this.obj_suppl_rids = [];
            this.obj_contract_number = null;
            this.$store.commit('request/setFilter', null);
            await this.openObj();
        },
        async openFilter() {
            this.dialog = true;

            await this.loadFilters({ ContractRid: this.SelectedContract.contract_rid, KSKRid: 0 });
        },
        async filterItems() {
            const obj = {
                address_rid: this.address_rids ? this.address_rids.join(', ') : null,
                engineer_rid: this.engineer_rids ? this.engineer_rids.join(', ') : null,
                exploit_area_rid: this.exploit_area_rids ? this.exploit_area_rids.join(', ') : null,
                exploit_district_rid: this.exploit_district_rids ? this.exploit_district_rids.join(', ') : null,
                district_rid: this.district_rids ? this.district_rids.join(', ') : null,
                obj_suppl_rid: this.obj_suppl_rids ? this.obj_suppl_rids.join(', ') : null,
                obj_contract_number: this.obj_contract_number
            };

            //items.district_rids ? Number(items.district_rids.match(/\d+/g).join('')) : null

            const processedArrayWithFilters = getFilterArray(obj);
            if (processedArrayWithFilters.length > 0) {
                let arrayFilter = {
                    where: [...processedArrayWithFilters]
                };
                this.$store.commit('request/setFilter', arrayFilter);
            } else {
                this.$store.commit('request/setFilter', null);
            }
            this.dialog = false;
            await this.openObj();
        },
        async openObj() {
            await this.getContractObjects({
                ContractRid: this.SelectedContract.contract_rid,
                iLimit: this.ObjectPagination.itemsPerPage,
                iOffset: 0
            });
        }
    },
    async mounted() {}
};
</script>
